import { companyCookieJs } from "./companyCookie.js";
import { CopyToClipboard } from "../common/forms.js";
import Modal from 'bootstrap/js/dist/modal';

export var shortListPageJs = {
    // Content request for AI prompts
    aiContentRequest: null,

    BtnExportShortList: function (textForCopy) {
        CopyToClipboard(textForCopy, "The link is copied.");
    },

    bindShortList: function () {
        $("button.shortlist-action").off('click.shortlist');
        $("button.shortlist-action").on('click.shortlist', function (e) {
            e.preventDefault();

            // Disable all buttons while processing
            $("button.shortlist-action").prop("disabled", true);
            $(this).addClass("company-card__button--loading disabled");

            // Try to add company in shortlist
            var companyId = $(this).attr("data-companyid");
            var forceRefresh = $(this).is("[data-force-refresh]");
            var companyInShortList = shortListPageJs.addToShortList(companyId);

            if (forceRefresh) {
                // Page will be reloaded, no further actions needed
                location.reload(true);
            }
            else {
                if (companySearchOptions.triggerUrl != 'undefined') {
                    $.ajax({
                        url: companySearchOptions.triggerUrl,
                        type: 'POST'
                    })
                    .done(function (data) {
                        var triggerHtml = $(data).html();
                        $("div.short-list-trigger").html(triggerHtml);
                    })
                    .always(function () {
                        var button = $("button.shortlist-action.disabled");
                        var companyId = $(button).data("companyid");
                        var companyInShortList = companyCookieJs.isCompanyInCookie(companyId);

                        // Re-enable all buttons after processing
                        $("button.shortlist-action").prop("disabled", false);
                        $("button.shortlist-action").removeClass("company-card__button--loading disabled");

                        // Update button status
                        if (companyInShortList) {
                            $(button).find("span.shortlist-add").addClass("d-none");
                            $(button).find("span.shortlist-remove").removeClass("d-none");
                        }
                        else {
                            $(button).find("span.shortlist-remove").addClass("d-none");
                            $(button).find("span.shortlist-add").removeClass("d-none");
                        }
                    });
                }
            }
        });
    },

    addToShortList: function (companyId) {
        if (!(companyId.length)) {
            console.log("Company id is missing or in wrong format.");
            return false;
        }

        var isCompanyInCookie = companyCookieJs.isCompanyInCookie(companyId);

        if (isCompanyInCookie) {
            companyCookieJs.removeCompanyFromCookie(companyId);
        }
        else {
            companyCookieJs.addCompanyToCookie(companyId);
        }

        // TODO: Verify that the cookie was actually written (return actual result from above operations instead)
        isCompanyInCookie = companyCookieJs.isCompanyInCookie(companyId);
        return isCompanyInCookie;
    },

    showEditor: function (event) {
        const container = $(event.currentTarget).closest('.ai-container');
        const contentEditor = container.find('.ai-content-editor');
        const contentView = container.find('.ai-content-view');

        // Set editor height to match content (up to max-height)
        const height = ($(contentView).outerHeight()) + "px";
        $(contentEditor).css('height', height);

        container.addClass('editing');
    },
    submitEditor: function (event) {
        const container = $(event.currentTarget).closest('.ai-container');
        const contentEditor = container.find('.ai-content-editor');
        const contentView = container.find('.ai-content-view');
        const contentEditorValue = $(contentEditor).val();
        const contentViewText = $(contentView).text();

        // Adding title and description to global object for PPTX export
        if (companySearchOptions) {
            if ($(contentEditor).is('textarea')) {
                companySearchOptions.description = contentEditorValue;
            }
            else {
                companySearchOptions.title = contentEditorValue;
            }
        }

        const aiGenerated = container.find('.editor-ai-generated');

        // If content is AI generated, check modifications
        if (!aiGenerated.hasClass('d-none')) {
            if (contentEditorValue != contentViewText) {
                // Content changed, hide AI generated label
                container.find('.editor-ai-generated').addClass('d-none');
            }
        }

        // Set view text to editor value
        $(contentView).text(contentEditorValue);
        container.removeClass('editing');
    },
    cancelEditor: function (event) {
        const container = $(event.currentTarget).closest('.ai-container');
        const contentEditor = container.find('.ai-content-editor');
        const contentView = container.find('.ai-content-view');
        const contentViewText = $(contentView).text();

        // Reset editor value to view text
        $(contentEditor).val(contentViewText);
        container.removeClass('editing');
    },
    showModal: function (modal, event) {
        // AI prompt button that triggered the modal
        const button = $(event.relatedTarget);

        // Get the properties for modal
        const container = button.closest('.ai-container');
        const targetId = container.attr('data-element-id'); // e.g. title123
        const targetElement = $('#' + targetId);
        const title = $(targetElement).data('modal-title'); // field (title, description)
        const url = $(targetElement).data('modal-url');

        // Update the modal's content.
        const confirmationModalElement = $(event.currentTarget);
        confirmationModalElement.find('.ai-modal-title')
            .text(title);

        // Set the confirm button 
        confirmationModalElement.find('.ai-modal-confirmButton')
            .data('target', targetId)
            .data('url', url)
            .off('click') // Unbind existing
            .on('click', (innerEvent) => {
                shortListPageJs.confirmPrompt(modal, innerEvent);
            });
    },
    hideModal: function (event) {
        var confirmationModal = $(event.currentTarget);

        if (shortListPageJs.aiContentRequest) {
            shortListPageJs.aiContentRequest.abort();
            shortListPageJs.aiContentRequest = null;
        }

        confirmationModal.find('.ai-modal-title')
            .text('');
        confirmationModal.find('.form-element__spinner')
            .hide();
        confirmationModal.find('.ai-modal-confirmButton')
            .prop('disabled', false)
            .removeClass('disabled');
    },
    confirmPrompt: function (confirmationModal, event) {
        const confirmButton = $(event.currentTarget);
        const confirmationModalElement = confirmButton.closest('.ai-content-modal');

        const targetId = confirmButton.data('target'); // e.g. title123
        const url = confirmButton.data('url');
        const targetElement = $('#' + targetId);

        // Disable the button and show the spinner
        confirmButton.prop('disabled', true).addClass('disabled');

        const spinner = confirmationModalElement.find('.form-element__spinner');
        spinner.show();

        shortListPageJs.aiContentRequest = $.ajax({
            url: url,
            type: 'POST'
        }).done((data) => {
            var container = targetElement.closest('.ai-container[data-element-id="' + targetId + '"]');
            const contentEditor = container.find('.ai-content-editor');
            const contentView = container.find('.ai-content-view');

            if (data && data !== '') {
                // Update the generated data to view
                contentEditor.val(data);
                contentView.text(data);

                // Show AI generated label
                container.find('.editor-ai-generated').removeClass('d-none');
            }

            shortListPageJs.aiContentRequest = null; // Done, clear the request
        }).always(() => {
            // Enable the button and hide the spinner
            spinner.hide();
            confirmButton.prop('disabled', false).removeClass('disabled');
            confirmationModal.hide(); // Modal.hide()
        });
            },
    initShortListAI: function () {
        // Get all AI content forms in a page (.ai-content-form)
        $('.ai-content-form').each(function () {
            const aiContentForm = $(this);
            const aiConfirmationModalElement = aiContentForm.find('.ai-content-modal');

            if (aiConfirmationModalElement.length) {
                const modal = new Modal(aiConfirmationModalElement);

                // Bind AI prompt button modal event within this form
                $(aiContentForm).find('.ai-toolbar-view .ai-toolbar-prompt-button').on('click', (event) => {
                    const button = event.currentTarget;
                    modal.show(button);
                });

                aiConfirmationModalElement[0].addEventListener('show.bs.modal', event => {
                    shortListPageJs.showModal(modal, event);
                });

                // TODO: Handle modal closing by outside clicking, ESC, X or cancel even if confirmation is pressed (also cancel the event?)
                aiConfirmationModalElement[0].addEventListener('hide.bs.modal', event => {
                    shortListPageJs.hideModal(event);
                });
            }

            // Prompt toolbar buttons
            $('.ai-toolbar .ai-toolbar-edit-button').on('click', shortListPageJs.showEditor);
            $('.ai-toolbar .ai-toolbar-submit-button').on('click', shortListPageJs.submitEditor);
            $('.ai-toolbar .ai-toolbar-cancel-button').on('click', shortListPageJs.cancelEditor);
        });
    }
}

$(function () {
    // Bind shortlist button events
    shortListPageJs.bindShortList();

    // Bind export toolbar button events + modal
    shortListPageJs.initShortListAI();
});